import './savelivefact/style';
import FormStructure from './savelivefact/form_structure';

export default FormStructure;